import { LazyLoader, showToast } from '@bp/ui-components';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { SynchronizationsTable } from '../../../../components/Synchronizations/tables/SynchronizationsTable';
import { useAuthClaims } from '../../../../hooks/useAuthClaims';
import { useConfirm } from '../../../../hooks/useConfirm';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { useUserConfigContext } from '../../../../hooks/useUserConfigContext';
import { createEvents } from '../../../../utils/eventsApi';

export const ManualSynchronizationPage = () => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const userConfigContext = useUserConfigContext();
  const schoolYear = userConfigContext.selectedSchoolYear;
  const permissions = usePermissionChecker();

  const { confirm, ConfirmationDialog } = useConfirm();

  async function handleSync() {
    const result = await confirm({
      title: t('synchronizations.confirmTitle'),
      message: t('synchronizations.confirmMessage'),
      confirmText: t('synchronizations.syncNow'),
    });

    if (result && schoolYear) {
      await createEvents({
        organizationUuid: pimAuthClaims.getOrganizationUuid(),
        schoolYearUuid: schoolYear?.uuid,
      });
      showToast(t('synchronizations.started'), { type: 'success' });
    }
  }

  return (
    <Page isForbidden={!permissions?.canManageSubstitution()} headline={t('synchronizations.manualSynchronization')}>
      <Suspense fallback={<LazyLoader transparent forceHeight='50vh' fullWidth size='xxl' />}>
        <SynchronizationsTable onSync={handleSync} />
      </Suspense>

      <ConfirmationDialog />
    </Page>
  );
};
